/**
 * http request helper
 * 抽象出了一层用于请求后端数据的 API
 * get 代表使用 get 方式请求
 * post 代表使用 post 方式请求
 * 统一进行了错误处理，在使用的时候只需要针对正确的数据进行处理
 * @usage
 *   get(url).then();
 *   post(url, params).then();
 */

import 'es6-promise';
import 'isomorphic-fetch';
import config from '../config';
import { formatObjToParamStr } from '../helper/common-helper';

/**
 * httpRequestService
 * @param url 请求的地址
 * @param options 请求的配置，比如，发送的数据和请求的方式
 * @param errorHandler 错误处理函数，可选参数，用于特殊的错误处理
 */
const httpRequestService = (url, errorHandler, options = null) => {
  return fetch(url, options || config.requestOptions)
  .then(res => {
    if (!res.ok) {
      console.error('获取数据失败，请重试');
      return {};
    }

    return res.json();
  })
  .catch(error => {
    if (errorHandler) {
      errorHandler();
    }
    console.error(error);
  });
};

export const get = (url, errorHandler) => httpRequestService(url, errorHandler);

export const post = (url, params, errorHandler) => {
  const postOptions = Object.assign(
    {},
    config.requestOptions,
    {
      method: 'POST',
      body: JSON.stringify(params || {}),
    }
  );

  return httpRequestService(url, errorHandler, postOptions);
};

// todo refactoring
export const getRequestUrl = (url, params) => {
  let requestUrl = url;
  const paramStr = formatObjToParamStr(params);

  if (paramStr) {
    const separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += `${separator}${paramStr}`;
  }

  return requestUrl;
};

export default {
  get(url, params) {
    const requestUrl = getRequestUrl(url, params);

    return get(requestUrl);
  },

  post(url, params) {
    return post(url, params);
  },

  goto(url, params) {
    const requestUrl = getRequestUrl(url, params);

    location.href = requestUrl;
  },
};



// WEBPACK FOOTER //
// ./src/helper/http-request-helper.js